document.addEventListener('DOMContentLoaded', function () {
  initProductGallery();
  var form = document.getElementById('ProductForm');
  if (form) initProductForm(form);
});

/* ---------- Gallery: color-filtered images, thumbnails, prev/next arrows ---------- */
function initProductGallery() {
  var mapScript = document.querySelector('[data-gallery-map]');
  if (!mapScript) return;

  var galleryMap;
  try {
    galleryMap = JSON.parse(mapScript.textContent);
  } catch (err) {
    return;
  }

  var mainImg = document.getElementById('ProductMainImage');
  var thumbsWrap = document.querySelector('[data-product-thumbs]');
  var prevBtn = document.querySelector('[data-gallery-prev]');
  var nextBtn = document.querySelector('[data-gallery-next]');
  var swatchButtons = document.querySelectorAll('[data-color-swatches] .color-swatch');
  var colorInput = document.querySelector('input[data-option-name="Color"]');
  var colorLabel = document.querySelector('[data-selected-color-label]');

  var currentImages = [];
  var currentIndex = 0;

  function imagesForColor(color) {
    return galleryMap.filter(function (img) {
      return img.colors.indexOf(color) !== -1;
    });
  }

  function renderThumbs() {
    if (!thumbsWrap) return;
    thumbsWrap.innerHTML = '';
    if (currentImages.length <= 1) return;
    currentImages.forEach(function (img, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'product__thumb' + (i === currentIndex ? ' product__thumb--active' : '');
      var thumbImg = document.createElement('img');
      thumbImg.src = img.thumb;
      thumbImg.alt = '';
      btn.appendChild(thumbImg);
      btn.addEventListener('click', function () {
        currentIndex = i;
        renderMain();
      });
      thumbsWrap.appendChild(btn);
    });
  }

  function renderMain() {
    if (mainImg && currentImages.length) {
      mainImg.src = currentImages[currentIndex].full;
    }
    if (thumbsWrap) {
      var thumbs = thumbsWrap.querySelectorAll('.product__thumb');
      thumbs.forEach(function (t, i) {
        t.classList.toggle('product__thumb--active', i === currentIndex);
      });
    }
  }

  function setColor(color) {
    currentImages = imagesForColor(color);
    currentIndex = 0;
    renderThumbs();
    renderMain();
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', function () {
      if (currentImages.length < 2) return;
      currentIndex = (currentIndex - 1 + currentImages.length) % currentImages.length;
      renderMain();
    });
  }
  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      if (currentImages.length < 2) return;
      currentIndex = (currentIndex + 1) % currentImages.length;
      renderMain();
    });
  }

  swatchButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      swatchButtons.forEach(function (b) { b.classList.remove('color-swatch--active'); });
      btn.classList.add('color-swatch--active');
      var color = btn.getAttribute('data-color-value');
      if (colorInput) colorInput.value = color;
      if (colorLabel) colorLabel.textContent = color;
      setColor(color);
      if (window.__quietMindOnOptionChange) window.__quietMindOnOptionChange();
    });
  });

  var initialColor = colorInput ? colorInput.value : null;
  if (initialColor) setColor(initialColor);
}

/* ---------- Variant sync: price, availability, cart id ---------- */
function initProductForm(form) {
  var variantsScript = form.querySelector('[data-variants-json]');
  if (!variantsScript) return;

  var variants;
  try {
    variants = JSON.parse(variantsScript.textContent);
  } catch (err) {
    return;
  }

  var controls = form.querySelectorAll('[data-option-name]');
  var hiddenId = form.querySelector('input[name="id"]');
  var addBtn = form.querySelector('[data-add-to-cart]');
  var priceEl = document.querySelector('[data-product-price]');

  function getSelectedOptions() {
    var vals = [];
    controls.forEach(function (c) { vals.push(c.value); });
    return vals;
  }

  function findVariant(vals) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var match = true;
      for (var j = 0; j < vals.length; j++) {
        if (v.options[j] !== vals[j]) { match = false; break; }
      }
      if (match) return v;
    }
    return null;
  }

  function onOptionChange() {
    var variant = findVariant(getSelectedOptions());

    if (!variant) {
      if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = 'Unavailable';
      }
      return;
    }

    if (hiddenId) hiddenId.value = variant.id;
    if (priceEl) priceEl.textContent = variant.price;
    if (addBtn) {
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available ? ('Add to Cart — ' + variant.price) : 'Sold Out';
    }
  }

  controls.forEach(function (c) {
    if (c.tagName === 'SELECT') {
      c.addEventListener('change', onOptionChange);
    }
  });

  // Called by the gallery module whenever a color swatch is clicked.
  window.__quietMindOnOptionChange = onOptionChange;
}

/* ---------- Mobile menu toggle ---------- */
document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('.site-header__menu-toggle');
  var nav = document.getElementById('SiteNav');
  if (!toggle || !nav) return;

  toggle.addEventListener('click', function () {
    var isOpen = nav.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });

  nav.querySelectorAll('a').forEach(function (link) {
    link.addEventListener('click', function () {
      nav.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    });
  });
});
